import { call, put, race, take, takeLatest } from 'redux-saga/effects';
import { getServiceProvider, IServiceProvider } from '../../../services';
import { emptyStringToUndefined } from '../../../utils/helper/strings';
import { ActionType } from '../../../utils/reduxUtils';
import { showSnackbar } from '../../common/utils/showSnackbar';
import { requireUserOrThrow } from '../../utils/sagas';
import actions from '../actions';

const sendProblemReportSaga = takeLatest(actions.sendProblemReportAsync.request.type, function* (
  action: ActionType<typeof actions.sendProblemReportAsync.request>
) {
  yield race({
    send: call(sendProblemReport, action),
    cancelled: take(actions.sendProblemReportAsync.cancel.type),
  });
});

const sendProblemReport = function* (action: ActionType<typeof actions.sendProblemReportAsync.request>) {
  const { username, email, onSuccess, ...rest } = action.payload;

  const serviceProvider: IServiceProvider = yield getServiceProvider();

  try {
    yield requireUserOrThrow();
    yield serviceProvider.api.sendTourProblemReport({
      ...rest,
      email: emptyStringToUndefined(email),
      username: emptyStringToUndefined(username),
    });
    yield put(actions.sendProblemReportAsync.success());
    yield showSnackbar({ key: 'play_tour.message_to_author_success' });
    onSuccess();
  } catch (e) {
    yield put(actions.sendProblemReportAsync.failure(e));
    serviceProvider.analyticsService.logError(e);
  }
};

const sagas = [sendProblemReportSaga];

export default sagas;
